import styles from './Footer.module.scss';

export function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className={styles.footer}>
      <div className={`container ${styles.inner}`}>
        <span>© {year} Rapolas Skripkauskas</span>
        <a href="#home">Back to top ↑</a>
      </div>
    </footer>
  );
}